/**
 * Created by mauget on 3/2/16.
 */

// SettingsDetailView.js

import $ from 'jquery';
import _ from 'lodash';

import { View } from 'backbone';

import DashboardModel   from 'DashboardModel.js';
import constants        from 'Constants.js';
import contentTemplate  from 'dashboard/settings/user-search-detail-view.ejs';
import BaseTableView from 'properties/BaseTableView.js'
import util from 'util/Util.js';
import RestService from 'RestService.js';
import eventBus         from 'EventBus.js';

class UserSearchDetailView extends BaseTableView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = contentTemplate;
        this.gridEl = constants.PROP_MAIN_TABLE;
        this.events = {
            'change input[type="text"],select ':'updateFilters',
            'click #view-user':'viewUserDetails',
            'click #goToSettings': 'goToSettings',
            'click #goToAccountSettings': 'goToAccountSettings'
        };
        this.filtering = false;

        this.model.set({
            colModel: [
                {
                    name: 'id',
                    index: 'id',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'name',
                    index: 'name',
                    editable: false
                },
                {
                    name: 'email',
                    index: 'email',
                    editable: false
                },
                {
                    name: 'role',
                    index: 'role',
                    editable: false
                },
                {
                    name: 'domainUsername',
                    index: 'domainUsername',
                    editable:false
                },
                {
                    name: 'customId',
                    index: 'customId',
                    editable:false
                }

            ],
            colNames: ['Id','Name','Email', 'Role', 'Domain Username','Custom Id']
        });

        var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: 'General User Information', route: '#users'}];

        this.model.set('dashboardTitle', 'General User Information', {silent:true});
        this.model.set('breadcrumbs', breadcrumbs, {silent:true});

        this.listenTo(this.model, 'change', this.render);
        this.onResize();
        return this;
    }

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize(){
        $(window).on('resize',() => {this.resizeGrid();})
    }

    updateFilters(event){
        // Saving search values inside the model, so the search can be preserved on renders.
        const targetValue = event.target.value;
        this.model.set('search-' + event.target.name, targetValue);

        //PF-6103 with autocomplete more than one input could be filled and trigger the change event x times causing errors on the web service response
        //to avoid this, set a flag if it is currently filtering and trigger the focus out event to keep checking until the previous filtering is done
        if(!this.filtering){
            this.filtering = true;
            this.performSearch();
        }else{
            $(event.target).trigger('blur');
        }
        
    }

    onCellSelect(rowId, iCol, cellContent,e){
        $(this.gridEl).jqGrid('setSelection',rowId);
        $("#view-user").prop('disabled',false);
    }

    ondblClickRow(rowId){
        this.switchToUserDetails(rowId);
    }

    viewUserDetails(event){
        event.preventDefault();
        let selRowId = $(this.gridEl).jqGrid('getGridParam', 'selrow');
        this.switchToUserDetails(selRowId);
    }

    switchToUserDetails(selectedRow){
        let rowData = $(this.gridEl).getRowData(selectedRow);
        let userIdToOpen=rowData['id'];
        const eventValues={
            detailPage: 'UserDetailsView',
            payload:{
                userId:userIdToOpen,
                parentFormId:this.model.get('formId')
            }
        };
        eventBus.trigger(constants.SWITCH_DETAIL_USER,eventValues);
    }

    performSearch(){

        // Adding the '%' wildcard to the input text searches if any, requested by the API.
        const firstName=this.model.get('search-firstName') ? this.model.get('search-firstName') + '%' : '%';
        const lastName=this.model.get('search-lastName') ? this.model.get('search-lastName') + '%' : '%';
        const email=this.model.get('search-email') ? this.model.get('search-email') + '%' : '%';
        const role=this.model.get('search-role') || '-1';
        const directoryServiceUserName=this.model.get('search-domainUsername') ? this.model.get('search-domainUsername') + '%' : '%';
        const customId=this.model.get('search-customId') ? this.model.get('search-customId') + '%' : '%';
        RestService.searchUsers(role,firstName,lastName,email,directoryServiceUserName,customId).then((userData)=>{
            
            this.model.set('totalRecords',userData.TotalRecords,{silent:true});
            if(userData.UserList) {
                let users = userData.UserList.User instanceof Array
                    ? userData.UserList.User
                    : [userData.UserList.User];
                this.model.set('gridData', users, {silent: true});
            }
            else{
                this.model.set('gridData', [], {silent: true});
            }

            var breadcrumbs = [
                {name: 'Settings', route: '#settings', id: 'goToSettings'},
                {name: 'Account Settings', id: 'goToAccountSettings'},
                {name: 'General User Information', route: '#users'}
            ];

            this.model.set('dashboardTitle', 'General User Information');
            this.model.set('breadcrumbs', breadcrumbs);
            this.render();
        }).finally(() => {
            this.filtering = false;
        });
    }

    render() {
        this.onRender();
        var gridData = this.model.get('gridData');
        console.log('User Search Data',gridData);

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        var self = this;
        let gridObject=util.getGridObject(self,{autowidth:true,scrollOffset:0});
        $(self.gridEl).jqGrid(gridObject);

        if(gridData) {
            gridData.forEach(function (value, index) {
                var newRow = {
                    'id': value['@id'],
                    'name': value['@firstName'] + ' ' + value['@lastName'],
                    'email': value['@email'],
                    'role': util.getRole(value['@status']),
                    'domainUsername': value['@dsUserName'],
                    'customId': value["@customId"]
                };
                $(self.gridEl).addRowData(index, newRow);
            });
        }

        $('#detailHeading').html('Settings - Dashboard');
        $(`option[value="${this.model.get('search-role')}"]`).prop('selected', true);
        $('.ui-jqgrid .ui-jqgrid-bdiv').css('overflow-x', 'hidden');

        this.resizeGrid();
        this.delegateEvents();

        this.afterRender();
        this.$el.css('cursor', 'default');
        return this;
    }

    remove(){
        $(window).off('resize');
        super.remove();
    }

    goToSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        eventBus.trigger('loadSettingsView');
    }

    goToAccountSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        $('div.document-heading > a[data-target="#well_1"]').click();
    }
}

export default UserSearchDetailView;

